export default __webpack_public_path__ + "static/media/bg-step.f25b6ced.png";